import axios from 'axios'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import {
  MixpanelEventName,
  MixpanelPropertiesName,
  MixpanelPropertiesValues,
  MixpanelTracking,
} from 'constant/mixpnael'
import { getThumbnailImage } from 'constant/functions'

const TemplatesCards = ({ template_id, category_id, title, isShowBtn, template_btn_title }) => {
  const router = useRouter()
  const [templates, setTemplates] = useState(null)

  useEffect(() => {
    let params = {
      page: 1,
    }
    if (category_id) {
      params.category_id = category_id
    }
    axios.get('/api/all_templates', { params }).then((res) => {
      setTemplates(res.data.data.listings)
    })
  }, [router])

  return (
    <div className="  ">
      <div className="flex justify-between items-center my-5  ">
        <h4 className="h4 m-0 text-black font-semibold">{title?.length > 0 && title}</h4>

        {isShowBtn && (
          <Link
            href={{
              pathname: `/templates`,
            }}
            passHref
          >
            <a className="btn-sm bg-primary hover:bg-transparent text-white hover:text-primary  ">
              See All
            </a>
          </Link>
        )}
      </div>
      <div className="grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start">
        {templates?.map((item) => {
          const Type = (attributes) => {
            return attributes.filter((at) => at.name === 'Type')[0]?.values[0]?.name
          }

          // is_active
          const is_active = (attributes) => {
            return attributes.filter((at) => at.name === 'Active')[0]?.values[0] == true
              ? true
              : undefined
          }

          if (template_id?.length > 0) {
            if (template_id.includes(item.id) && is_active(item.attributes)) {
              return (
                <div className="flex flex-col h-full sha rounded-md overflow-hidden  border border-[#eaeaea]      hover:shadow-medium    p-3  transition-all duration-300">
                  <header className="mb-5">
                    <div className=" w-full h-[200px] block relative mb-5 overflow-hidden ">
                      <img
                        className="w-full h-full object-cover object-top "
                        src={getThumbnailImage(item.images[0])}
                        alt=""
                      />
                    </div>

                    <h3 className=" px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center">
                      {item.title.length > 20 ? item.title.substr(0, 20) + '..' : item.title}
                    </h3>
                  </header>

                  <footer>
                    <a
                      href={`/templates/${item.slug}`}
                      className="btn w-full bg-primary  hover:bg-white text-white hover:text-primary  border border-transparent hover:border-primary transition duration-300 "
                      onClick={() => {
                        MixpanelTracking(MixpanelEventName.click_template_on_embed, {
                          [MixpanelPropertiesName.referrer]: router.pathname,
                          [MixpanelPropertiesName.template_slug]: item.slug,
                        })
                      }}
                    >
                      {template_btn_title ? template_btn_title : 'GET TEMPLATE'}
                    </a>
                  </footer>
                </div>
              )
            }
          } else {
            if (is_active(item.attributes)) {
              return (
                <div className="flex flex-col h-full sha rounded-md overflow-hidden  border border-[#eaeaea]      hover:shadow-medium    p-3  transition-all duration-300">
                  <header className="mb-5">
                    <div className=" w-full h-[200px] block relative mb-5 overflow-hidden ">
                      <img
                        className="w-full h-full object-cover object-top "
                        src={getThumbnailImage(item.images[0])}
                        alt=""
                      />
                    </div>

                    <h3 className=" px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center">
                      {item.title.length > 20 ? item.title.substr(0, 20) + '..' : item.title}
                    </h3>
                  </header>

                  <footer>
                    <a
                      href={`/templates/${item.slug}`}
                      className="btn w-full bg-primary  hover:bg-white text-white hover:text-primary  border border-transparent hover:border-primary transition duration-300 "
                      onClick={() => {
                        MixpanelTracking(MixpanelEventName.click_template_on_embed, {
                          [MixpanelPropertiesName.referrer]: router.pathname,
                          [MixpanelPropertiesName.template_slug]: item.slug,
                        })
                      }}
                    >
                      {template_btn_title ? template_btn_title : 'GET TEMPLATE'}
                    </a>
                  </footer>
                </div>
              )
            }
          }
        })}
      </div>
    </div>
  )
}

export default TemplatesCards
